export default defineNuxtPlugin( () => {
  const commerceAnalytics = useCommerceAnalytics();

  useRuntimeHook( "apollo:basket:add", async ( response ) => {
    if ( response != null ) {
      if ( response.addResults ) {
        commerceAnalytics.onAddToBasket( response.addResults );
      }
    }
  } );

  useRuntimeHook( "apollo:basket:remove", async ( items ) => {
    if ( items ) {
      commerceAnalytics.onRemoveFromBasket( items );
    }
  } );
} );
